// LUMINA · pages/vajra/admin/CredentialsSection.jsx
// Phase 39D: extracted from AdminHub.jsx — wraps CredentialManager component

import React from 'react';
import CredentialManager from '../components/CredentialManager';

export default function CredentialsSection({ token, headers, memberList, loadAdminData }) {
  return (
    <CredentialManager
      token={token}
      headers={headers}
      memberList={memberList}
      loadAdminData={loadAdminData}
    />
  );
}
